import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CashPluckingRateMappingListing, CashPluckingRateMappingAddEdit } from './Pages';

export const CashPluckingRateMapping = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={CashPluckingRateMappingListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={CashPluckingRateMappingAddEdit} />
    </Fragment>
)